var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var MediaTypeController = {
    /*****************************************************************************************************
        * Is using route "api/mediaType" and http method "POST" to call the back-end.
    
        * @param {string[]} mediaTypes
        * @returns {Record<string, string[]>}
    ******************************************************************************************************/
    GetFileEndings: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/mediaType", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.mediaTypes
        });
    },
    /*****************************************************************************************************
        * Is using route "api/mediaType/startingWith" and http method "POST" to call the back-end.
    
        * @param {string[]} starts
        * @returns {string[]}
    ******************************************************************************************************/
    GetMimeTypesStartingWith: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/mediaType/startingWith", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.starts
        });
    },
    /*****************************************************************************************************
        * Is using route "api/mediaType/extension" and http method "POST" to call the back-end.
    
        * @param {MediaUploadDto} data
        * @returns {string}
    ******************************************************************************************************/
    GetExtension: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/mediaType/extension", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=MediaTypeController.js.map